import axios from '../plugins/axios'

export default {
  create(params){
    return axios.post('/api/v1/custom_plans/create', params)
  },
  subscribe(id, coupon_code){
    return axios.post('/api/v1/custom_plans/subscribe/' + id, {
      coupon_code: coupon_code
    })
  },
  destroy(id){
    return axios.delete('/api/v1/custom_plans/destroy/' + id)
  },
  check_coupon_exists(plan_id, coupon_code){
    return axios.post('/api/v1/custom_plans/check_coupon', {
      plan_id: plan_id,
      coupon_code: coupon_code,
    })
  },
}
